<template>
  <div :class="$style.wrapper">
    <slot name="header" />
    <div :class="[$style.content, isDark && $style.isDark]">
      <div
        id="content"
        :class="$style.contentWrapper"
      >
        <slot />
      </div>
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'MainTemplate',
  props: {
    isDark: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../assets/scss/variables";

  .wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    max-width: 100vw;
    overflow: hidden;
  }
  .contentWrapper {
    width: 100vw;
    flex: 1;
    overflow-x: hidden;
    display: flex;
  }
  .content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    width: 100vw;
    overflow-y: auto;
    overflow-x: hidden;

    &.isDark {
      background-color: $color-midnight-blue;
      color: $color-white;
    }
  }
</style>
